"use client";

import dynamic from "next/dynamic";

import { useIsLoggedIn } from "../../shared/is-logged-in";

const WelcomeFocusDialog = dynamic(() => import("./welcome-focus-dialog"));

const WelcomeFocus = () => {
  const isLoggedIn = useIsLoggedIn();

  return !isLoggedIn ? <WelcomeFocusDialog /> : null;
};

export default WelcomeFocus;
